<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">TBA Marketing Promotions</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Marketing</b> /
      <b>Promotions</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active promotions -->
        <div class="card text-left">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="home-basic-tab"
                data-toggle="tab"
                href="#_promotion"
                role="tab"
                aria-controls="_promotion"
                aria-selected="true"
                >Promotions</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="profile-basic-tab"
                data-toggle="tab"
                href="#_advert"
                role="tab"
                aria-controls="_advert"
                aria-selected="false"
                >Advert</a
              >
            </li>
          </ul>

          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active bg-white" id="_promotion" role="tabpanel" aria-labelledby="individual-tab">
              <div class="card-body">
                <router-link
                  :to="newPromotion()"
                  type="button"
                  class="btn btn-primary btn-rounded"
                >
                  New Promotion
                </router-link>

                <br />
                <br />

                <h4 class="card-title mb-3">Active</h4>

                <div class="table-responsive">
                  <table
                    id="active_tbl"
                    class="display table table-striped table-bordered"
                    style="width:100%; text-align: center;"
                  >
                    <thead>
                      <tr>
                        <th>No.</th>
                        <th>Title</th>
                        <th>Content</th>
                        <th>Created By</th>
                        <th>Created At</th>
                        <th>Image</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(proActive, i) in active" :key="i">
                        <td>{{ i + 1 }}</td>
                        <td>{{ proActive.title }}</td>
                        <td>{{ proActive.content }}</td>
                        <!-- Staff referes to user table -->
                        <td>{{ proActive.staff_name }}</td>
                        <td>
                          {{
                            proActive.created_at | moment("Do MMMM YYYY, h:mm a")
                          }}
                        </td>
                        <td>
                          <img
                            :id="'Act' + proActive.id"
                            :src="proActive.image_link"
                            style="width: 200px; height: 200px"
                            class="mx-auto"
                          />
                        </td>
                        <td>
                          <button
                            @click="deactivate(proActive.id)"
                            class="btn btn-success btn-rounded btn-block"
                            style="background-color: #78BE20; border-color: #78BE20;"
                          >
                            Deactivate
                          </button>

                          <br />

                          <router-link
                            :to="proUpdate(proActive.id)"
                            type="button"
                            class="btn btn-success btn-rounded btn-block"
                            style="background-color: #78BE20; border-color: #78BE20;"
                          >
                            Edit Details
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>


                <br/>
                <hr/>
                <br/>

                <!-- Deactivated promotions -->
                <div class="text-left">
                  <h4 class="card-title mb-3">Deactivated</h4>

                  <div class="table-responsive">
                    <table
                      id="deactivated_tbl"
                      class="display table table-striped table-bordered"
                      style="width:100%; text-align: center;"
                    >
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Title</th>
                          <th>Content</th>
                          <th>Created By</th>
                          <th>Created At</th>
                          <!-- <th>Start At</th>
                        <th>End At</th> -->
                          <th>Image</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(proDeactive, i) in deactive" :key="i">
                          <td>{{ i + 1 }}</td>
                          <td>{{ proDeactive.title }}</td>
                          <td>{{ proDeactive.content }}</td>
                          <td>{{ proDeactive.staff_name }}</td>
                          <td>
                            {{
                              proDeactive.created_at | moment("Do MMMM YYYY, h:mm a")
                            }}
                          </td>
                          <!-- <td>{{ proDeactive.start_time | moment("Do MMMM YYYY, h:mm a") }}</td>
                            <td>{{ proDeactive.end_time | moment("Do MMMM YYYY, h:mm a") }}</td> -->
                          <td>
                            <img
                              :id="'De' + proDeactive.id"
                              :src="(proDeactive.image_link)"
                              style="width: 200px; height: 200px"
                              class="mx-auto"
                            />
                          </td>
                          <td>
                            <button
                              @click="activate(proDeactive.id)"
                              class="btn btn-success btn-rounded btn-block"
                              style="background-color: #78BE20; border-color: #78BE20;"
                            >
                              Activate
                            </button>

                            <br />

                            <router-link
                              :to="proUpdate(proDeactive.id)"
                              type="button"
                              class="btn btn-success btn-rounded btn-block"
                              style="background-color: #78BE20; border-color: #78BE20;"
                            >
                              Edit Details
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- End of Deactivated promotions -->
              </div>
            </div>

            <!-- different tabs -->
            <div class="tab-pane fade bg-white" id="_advert" role="tabpanel" aria-labelledby="multiple-tab">
              <Advert />
            </div>
          </div>
        </div>
        <!-- End of Active promotions -->

        <br />

        
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";
import Advert from "./advert"

export default {

  components: {
    Advert
  },

  name: "promotion-main-page",

  data() {
    return {
      active: [],
      deactive: [],
      image_link: ""
    };
  },

  methods: {
    async loadActivePromotions() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        let res = await axios
          .get("/promotions/active", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          this.active = res.data;
      }
    },

    async loadDeactivatePromotions() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        let res = await axios
          .get("/promotions/deactive", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
            this.deactive = res.data;
      }
    },

    deactivate(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/promotions/deactivate/" + id,
                {
                  _method: "PATCH"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                this.destroyDatatable();
                this.loadAllData();
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    activate(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        swal({
          icon: "warning",
          text: "Are you sure?",
          buttons: ["Cancel", "Yes"]
        }).then(confirm => {
          if (confirm) {
            axios
              .post(
                "/promotions/activate/" + id,
                {
                  _method: "PATCH"
                },
                {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                }
              )
              .then(res => {
                this.destroyDatatable();
                this.loadAllData();
              });
          } else {
            swal({
              icon: "info",
              text: "Cancelled"
            });
          }
        });
      }
    },

    getActiveImgUrl(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("promotions/" + id + "/image", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            let link = String(res.config.url);

            $("#Act" + id).attr("src", link);
          });
      }
    },

    getDeactiveImgUrl(id) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("promotions/" + id + "/image", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            let link = String(res.config.url);

            $("#De" + id).attr("src", link);
          });
      }
    },

    proUpdate(id) {
      return "/promotion/update/" + id;
    },

    newPromotion() {
      return "/marketing/promotion/new";
    },

    destroyDatatable() {
      $("#active_tbl")
        .DataTable()
        .destroy();
      $("#deactivated_tbl")
        .DataTable()
        .destroy();
    },

    setDatatable() {
      $("#active_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5]
            }
          }
        ]
      });

      $("#deactivated_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5]
            }
          }
        ]
      });
    },

    async loadAllData() {
      await this.loadActivePromotions();
      await this.loadDeactivatePromotions();
      this.setDatatable();
    }
  },

  async mounted() {
    await this.loadAllData();
  }
};
</script>
